import Eventful from '@byted/light-render/lib/utils/Eventful';
var hooks = new Eventful();
export default hooks;
export function registerBeforeRenderHook(fn) {
    hooks.on('beforerender', fn);
}
export function registerAfterRenderHook(fn) {
    hooks.on('afterrender', fn);
}
